import React from 'react';

function App() {
  return (
    <main>
      <h1>WIP</h1>
    </main>
  );
}

export default App;
